'use client'
import * as React from 'react'

import { SidebarContent, SidebarGroup } from '@/components/ui/sidebar'

import { Accordion } from '@/components/ui/accordion'
import { ChipSelect } from '@/components/main/contests/chip-select'

import { EducationalLevelAccordion } from '../filter/sections/educational-level'
import { RegionAccordion } from '../filter/sections/region'
import { MemberAccordion } from '../filter/sections/member'
// import { UniversityAccordion } from '../filter/sections/university'
import { RewardAccordion } from '../filter/sections/reward'
import { SortbySection } from '../filter/sections/sortby'
import {
  usePreferenceData,
  useUpdatePreference,
} from '@/hooks/api/use-preference'
import { useContestPreferenceStore } from '@/stores/contest-preference-store'
import { getAuthHeader } from '@/services/api/client'
// import { InternationalAccordion } from '../filter/sections/international'

export function AppSidebarContent() {
  const { preference, refetch } = usePreferenceData()
  const { updatePreference } = useUpdatePreference()
  const store = useContestPreferenceStore()

  async function handleSavePreference() {
    updatePreference({
      headers: getAuthHeader(),
      body: {
        category_ids: store.categories,
        certificate: store.certificate,
        company_partnership: store.companyPartnership,
        internship: store.internship,
        // educational_level: store.educationalLevels
        // member_type: store.memberTypes,
        open_date: store.openDate?.toISOString(),
        closing_date: store.closingDate?.toISOString(),
        prize_number_max: store.prizeNumberMax,
        prize_number_min: store.prizeNumberMin,
        publish_work: store.publishWork,
        // region: store.regions,
        show_only_active: store.isViewActiveContests,
        // sort_by: store.sortBy,
        sort_order: store.sortOrder,
        team_number_max: store.teamNumberMax,
        team_number_min: store.teamNumberMin,
      },
    })
    refetch()
  }

  return (
    <SidebarContent>
      <SidebarGroup className="grid gap-4">
        <div className="grid gap-2">
          <h2 className="font-darkergrotesque text-xl font-bold">
            Interested Categories
          </h2>

          <ChipSelect align="left" onFilterChange={() => {}} />
        </div>

        <div className="grid gap-2">
          <h2 className="font-darkergrotesque text-xl font-bold">Filters</h2>

          <Accordion type="multiple">
            <EducationalLevelAccordion
              educationalLevels={store.educationalLevels}
              setEducationalLevels={store.setEducationalLevels}
            />
            <RegionAccordion
              regions={store.regions}
              setRegions={store.setRegions}
            />
            <MemberAccordion
              memberTypes={store.memberTypes}
              setMemberTypes={store.setMemberTypes}
              setTeamNumberMax={store.setTeamNumberMax}
              setTeamNumberMin={store.setTeamNumberMin}
            />
            {/* <UniversityAccordion/> */}
            <RewardAccordion
              certificate={store.certificate}
              companyPartnership={store.companyPartnership}
              internship={store.internship}
              isBooleanOptionActive={store.isBooleanOptionActive}
              isPrizeSliderActive={store.isPrizeSliderActive}
              publishWork={store.publishWork}
              setCertificate={store.setCertificate}
              setCompanyPartnership={store.setCompanyPartnership}
              setInternship={store.setInternship}
              setIsBooleanOptionActive={store.setIsBooleanOptionActive}
              setIsPrizeSliderActive={store.setIsPrizeSliderActive}
              setPrizeNumberMax={store.setPrizeNumberMax}
              setPrizeNumberMin={store.setPrizeNumberMin}
              setPublishWork={store.setPublishWork}
              setTrophy={store.setTrophy}
              trophy={store.trophy}
            />
            {/* <InternationalAccordion /> */}
          </Accordion>

          <SortbySection
            setSortBy={store.setSortBy}
            setSortOrder={store.setSortOrder}
          />

          <div className="mt-[25px] flex w-auto cursor-pointer items-center justify-center rounded-full bg-black px-4 py-2 text-[14px]">
            <button
              onClick={handleSavePreference}
              className="font-bold text-white"
            >
              Save preferences
            </button>
          </div>
        </div>
      </SidebarGroup>
    </SidebarContent>
  )
}
